module.exports = __webpack_public_path__ + "static/media/pacman.275993c2.png";